export const soon = {
  title: "Come Back Later...",
  body: `<br />
    <h1>Привет, ты слишком рано!</h1>
    <br /><br /><br />
    <p>
        Ты слишком рано пришла, ты должна быть терпеливой до тех пор, пока время не придет, не правда ли?
    </p>
    <br />
    <p>Время до начала: <span id="timer" style="font-size: 2em;"></span></p>
`,
};

export const late = {
  title: "See you next time...",
  body: `<br />
    <h1>The party was over</h1>
    <br /><br /><br />
    <p>
        Yes, my gift for you is kinda simple, cheap, and weird ? &#128534<br>
        B-but. It's only for you. &#128150
    </p>
`,
};
